import React from 'react';
import { PauseSmall, PlaySmall } from '@wix/wix-ui-icons-common';

type PlayPauseButtonProps = {
  isPlaying: boolean;
  onToggle: () => void;
  translations: {
    ariaLabel?: string;
  };
  className?: string;
};

export const PlayPauseButton = ({
  isPlaying,
  onToggle,
  translations,
  className,
}: PlayPauseButtonProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.code === 'Space') {
      onToggle();
      e.preventDefault();
    }
  };

  return (
    <button
      className={className}
      onKeyDown={handleKeyDown}
      aria-label={translations.ariaLabel}
      aria-pressed={isPlaying}
    >
      {isPlaying ? <PauseSmall /> : <PlaySmall />}
    </button>
  );
};
